import { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { checkUserExistence, loginUser } from "services/authService";
import { updateInitialState } from "slice/merchantSlice";
import { updateHostState } from "slice/hostSlice";
import { actions } from "components/layout/appLayoutSlice";
import { FormikProps, useFormik } from "formik";
import { SignInFormProps } from "../types/sign-up-form-types";
import { storeUserData } from "utils/storage";
import { initializeSession } from "sessionManager";

const useSignInLogic = () => {
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik: FormikProps<SignInFormProps> = useFormik<SignInFormProps>({
    initialValues: {
      countryCode: "+91",
      loginInput: "",
      password: "",
      emailId: "",
      userType: "merchant",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required("Required"),
      countryCode: Yup.string().required("Required"),
    }),
    async onSubmit(values, formikHelpers) {
      
    },
  });

  const handleSubmit = async () => {
    const { loginInput, password, countryCode, userType } = formik.values;
    const isMobile = /^[0-9]{10}$/.test(loginInput);

    if (!loginInput || (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginInput) && !isMobile)) {
      toast.error("Please enter a valid mobile number or email", { position: "top-right" });
      return;
    }

    if (!isPasswordEnabled) {
      setIsChecking(true);
      try {
        const response = await checkUserExistence(loginInput,userType);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setIsPasswordEnabled(true);
          toast.success("User found. Please enter your password.", { position: "top-right" });
        } else {
          toast.error("User not found. Please sign up first.", { position: "top-right" });
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again later.", { position: "top-right" });
      } finally {
        setIsChecking(false);
      }
    } else {
      setIsLoading(true);
      try {
        const response = await loginUser(loginInput, password, userType, countryCode) as any;
        toast.success("Login successful!", { position: "top-right" });
        const userId = response?.data?.user?.userId;
        storeUserData({ userId , userType })
        initializeSession();
        if(userType === "merchant"){
          dispatch(updateInitialState({...response?.data?.user}));
        }
        else{
          dispatch(updateHostState({...response?.data?.user }));
        }
        dispatch(actions.setUserDetails(response?.data?.user))
        navigate(userType === "merchant" ? "/merchant-basic-details" : "/basic-details");
      } catch (error: any) {
        if (error.response?.status === 401) {
          toast.error("Incorrect Password.", { position: "top-right" });
        } else {
          toast.error("Failed to log in. Please try again later.", { position: "top-right" });
        }
      } finally {
        setIsLoading(false);
      }
    }
  };
  return { formik, isPasswordEnabled, isChecking, isLoading, handleSubmit };
};

export default useSignInLogic;
